// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo-module--logo--38Wrw","logoNotLogged":"header_logo-module--logoNotLogged--XRVyx"};